import { render, staticRenderFns } from "./ShelfManage.vue?vue&type=template&id=e945379e&scoped=true"
import script from "./ShelfManage.vue?vue&type=script&lang=js"
export * from "./ShelfManage.vue?vue&type=script&lang=js"
import style0 from "./ShelfManage.vue?vue&type=style&index=0&id=e945379e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e945379e",
  null
  
)

export default component.exports